import React from 'react';
import { CheckIcon } from 'lucide-react';
interface Step {
  id: string;
  label: string;
}
interface StepIndicatorProps {
  steps: Step[];
  currentStepIndex: number;
  direction?: 'horizontal' | 'vertical';
}
export function StepIndicator({
  steps,
  currentStepIndex,
  direction = 'vertical'
}: StepIndicatorProps) {
  return <nav aria-label="Progress" data-id="element-189">
      <ol role="list" className={`flex ${direction === 'vertical' ? 'flex-col gap-6' : 'flex-row items-center gap-4'}`} data-id="element-190">
        {steps.map((step, index) => {
        const isCompleted = index < currentStepIndex;
        const isCurrent = index === currentStepIndex;
        return <li key={step.id} className={`relative ${direction === 'horizontal' ? 'flex-1' : ''}`} data-id="element-191">
              <div className={`flex items-center ${direction === 'vertical' ? 'gap-4' : 'flex-col gap-2 text-center'}`} data-id="element-192">
                <span className={`
                  flex items-center justify-center w-8 h-8 rounded-full border-2 text-sm font-medium transition-colors
                  ${isCompleted ? 'bg-primary border-primary text-primary-foreground' : isCurrent ? 'border-primary text-primary' : 'border-border text-muted-foreground'}
                `} data-id="element-193">
                  {isCompleted ? <CheckIcon className="w-4 h-4" data-id="element-194" /> : index + 1}
                </span>
                <span className={`text-sm font-medium ${isCurrent ? 'text-foreground' : 'text-muted-foreground'}`} data-id="element-195">
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && direction === 'vertical' && <div className="absolute left-4 top-10 bottom-[-1.5rem] w-px bg-border -ml-px" aria-hidden="true" data-id="element-196" />}
              {index < steps.length - 1 && direction === 'horizontal' && <div className="hidden sm:block absolute top-4 left-[calc(50%+1.5rem)] right-[calc(-50%+1.5rem)] h-px bg-border" aria-hidden="true" data-id="element-197" />}
            </li>;
      })}
      </ol>
    </nav>;
}